import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

const CTA = ({ cta }) =>
  cta.href.startsWith('/') ? <CTAInternal cta={cta} /> : <CTAExternal cta={cta} />;

const CTAInternal = ({ cta }) => (
  (<Link
    href={cta.href}
    className={cn(cta.colors.bg, cta.colors.text, cta.border, 'text-base font-medium tracking-wide px-6 py-4 leading-4 inline-block rounded-full whitespace-nowrap mr-6 last:mr-0')}>

    {cta.text}

  </Link>)
);

const CTAExternal = ({ cta }) => (
  <a
    href={cta.href}
    className={cn(cta.colors.bg, cta.colors.text, cta.border, 'text-base font-medium tracking-wide px-6 py-4 leading-4 inline-block rounded-full whitespace-nowrap mr-3 last:mr-0')}
  >
    {cta.text}
  </a>
);

CTA.defaultProps = {
  text: 'Get Started',
  href: 'https://dashboard.scale.com/signup',
  colors: {
    bg: 'bg-black',
    text: 'text-white'
  },
  border: ''
};

export default CTA;
